module.exports = __webpack_public_path__ + "assets/7754fa3969dae24290e38f31d1d5a66c.svg";